import { render, staticRenderFns } from "./okrWorkHome.vue?vue&type=template&id=8fc4fa1e&scoped=true&"
import script from "./okrWorkHome.vue?vue&type=script&lang=js&"
export * from "./okrWorkHome.vue?vue&type=script&lang=js&"
import style0 from "./okrWorkHome.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./okrWorkHome.vue?vue&type=style&index=1&id=8fc4fa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc4fa1e",
  null
  
)

component.options.__file = "okrWorkHome.vue"
export default component.exports